import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { useValidationService } from "../../../../../services/hooks/index.js";
import { Dialog, DialogContent } from "../../../../../Dialog/index.js";
import { Button } from "../../../../../Button/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { Box } from "../../../../../Box/index.js";
import { MultipleFileInput, TextInput } from "../../../../index.js";
import { useForm } from "../../hooks/index.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const MIN_IMAGE_WIDTH = 160;
const MIN_IMAGE_HEIGHT = 90;
const AddImagesGalleryDialog = (t0)=>{
    const $ = c(53);
    const { open, onClose, addImages } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [images, setImages] = useState(t1);
    const [description, setDescription] = useState();
    const validator = useValidationService();
    let t2;
    if ($[1] !== images) {
        t2 = {
            images
        };
        $[1] = images;
        $[2] = t2;
    } else t2 = $[2];
    const allValues = t2;
    let t3;
    if ($[3] !== validator) {
        t3 = validator.required();
        $[3] = validator;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== validator) {
        t4 = validator.sizeLimit("\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B jpeg, png, webp, tiff, dng \u0438\u043B\u0438 heif \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 10\u041C\u0411", {
            field: "image",
            sizeLimit: 10
        });
        $[5] = validator;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== validator) {
        t5 = validator.requiredIfFile("\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B jpeg, png, webp, tiff, dng \u0438\u043B\u0438 heif \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 10\u041C\u0411", {
            field: "image",
            fileTypes: [
                "image/jpeg",
                "image/png",
                "image/webp",
                "image/dng",
                "image/heif",
                "image/heic",
                "image/tiff"
            ]
        });
        $[7] = validator;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== validator) {
        t6 = validator.imageResolutionCheck(`Размер изображения не может быть меньше ${MIN_IMAGE_WIDTH} х ${MIN_IMAGE_HEIGHT}`, {
            minWidth: MIN_IMAGE_WIDTH,
            minHeight: MIN_IMAGE_HEIGHT
        });
        $[9] = validator;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
        t7 = {
            images: [
                t3,
                t4,
                t5,
                t6
            ]
        };
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    const fieldValidators = t7;
    const { errors, touched, validateField, hasValidationErrors, showError } = useForm(allValues, fieldValidators);
    let t8;
    if ($[16] !== showError || $[17] !== validateField) {
        t8 = (value)=>_async_to_generator(function*() {
                setImages(value);
                yield validateField("images", value);
                showError("images");
            })();
        $[16] = showError;
        $[17] = validateField;
        $[18] = t8;
    } else t8 = $[18];
    const handleChangeImagesGalleryInput = t8;
    let t9;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (value_0)=>{
            setDescription(()=>value_0 || "");
        };
        $[19] = t9;
    } else t9 = $[19];
    const handleChangeDescriptionInput = t9;
    let t10;
    if ($[20] !== addImages || $[21] !== description || $[22] !== images || $[23] !== onClose) {
        t10 = ()=>{
            onClose();
            if (images) addImages(images, description);
        };
        $[20] = addImages;
        $[21] = description;
        $[22] = images;
        $[23] = onClose;
        $[24] = t10;
    } else t10 = $[24];
    const handleSubmit = t10;
    let t11;
    if ($[25] !== onClose) {
        t11 = /*#__PURE__*/ jsx(Button, {
            variant: "tertiaryLight",
            size: "large",
            onClick: onClose,
            children: "Отменить"
        });
        $[25] = onClose;
        $[26] = t11;
    } else t11 = $[26];
    const t12 = hasValidationErrors || images.length < 2 || images.length > 10;
    let t13;
    if ($[27] !== t12) {
        t13 = /*#__PURE__*/ jsx(Button, {
            type: "submit",
            variant: "primary",
            size: "large",
            disabled: t12,
            children: "Добавить"
        });
        $[27] = t12;
        $[28] = t13;
    } else t13 = $[28];
    let t14;
    if ($[29] !== t11 || $[30] !== t13) {
        t14 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t11,
                t13
            ]
        });
        $[29] = t11;
        $[30] = t13;
        $[31] = t14;
    } else t14 = $[31];
    let t15;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ jsx("br", {});
        $[32] = t15;
    } else t15 = $[32];
    let t16;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ jsxs(Typography, {
            variant: "body1",
            color: "text.light.secondary",
            children: [
                "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043C\u0438\u043D\u0438\u043C\u0443\u043C 2 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F.",
                t15,
                "\u0424\u043E\u0440\u043C\u0430\u0442 \u043E\u0442 160 \xD7 90\n                  \u043F\u0438\u043A\u0441\u0435\u043B\u0435\u0439 \u0438 \u0432\u0435\u0441 \u0434\u043E 10\u041C\u0411.",
                /*#__PURE__*/ jsx("br", {}),
                "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0431\u0443\u0434\u0443\u0442 \u0432\n                  \u0441\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u0441\u0442\u043E\u0440\u043E\u043D 16:9"
            ]
        });
        $[33] = t16;
    } else t16 = $[33];
    const t17 = touched.images && !!errors.images;
    const t18 = touched.images ? errors.images : void 0;
    let t19;
    if ($[34] !== handleChangeImagesGalleryInput || $[35] !== images || $[36] !== t17 || $[37] !== t18) {
        t19 = /*#__PURE__*/ jsx(MultipleFileInput, {
            required: true,
            label: "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
            value: images,
            description: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0434\u043E 10 \u0444\u0430\u0439\u043B\u043E\u0432 \u0441 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u043C\u0438",
            dropzoneText: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0434\u043E 10 \u0444\u0430\u0439\u043B\u043E\u0432",
            onChange: handleChangeImagesGalleryInput,
            error: t17,
            helperText: t18
        });
        $[34] = handleChangeImagesGalleryInput;
        $[35] = images;
        $[36] = t17;
        $[37] = t18;
        $[38] = t19;
    } else t19 = $[38];
    let t20;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ jsx(TextInput, {
            name: "description",
            label: "\u041F\u043E\u0434\u043F\u0438\u0441\u044C",
            placeholder: "\u041F\u043E\u0434\u043F\u0438\u0441\u044C \u043A \u0433\u0430\u043B\u0435\u0440\u0435\u0435 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0439",
            onChange: handleChangeDescriptionInput
        });
        $[39] = t20;
    } else t20 = $[39];
    let t21;
    if ($[40] !== t19) {
        t21 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            flexDirection: "column",
            gap: "24",
            children: [
                t16,
                /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    flexDirection: "column",
                    gap: "8",
                    children: [
                        t19,
                        t20
                    ]
                })
            ]
        });
        $[40] = t19;
        $[41] = t21;
    } else t21 = $[41];
    let t22;
    if ($[42] !== onClose || $[43] !== t14 || $[44] !== t21) {
        t22 = /*#__PURE__*/ jsx(DialogContent, {
            title: "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0433\u0430\u043B\u0435\u0440\u0435\u0438 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0439",
            onClose: onClose,
            actions: t14,
            children: t21
        });
        $[42] = onClose;
        $[43] = t14;
        $[44] = t21;
        $[45] = t22;
    } else t22 = $[45];
    let t23;
    if ($[46] !== handleSubmit || $[47] !== t22) {
        t23 = /*#__PURE__*/ jsx("form", {
            onSubmit: handleSubmit,
            children: t22
        });
        $[46] = handleSubmit;
        $[47] = t22;
        $[48] = t23;
    } else t23 = $[48];
    let t24;
    if ($[49] !== onClose || $[50] !== open || $[51] !== t23) {
        t24 = /*#__PURE__*/ jsx(Dialog, {
            open: open,
            onClose: onClose,
            children: t23
        });
        $[49] = onClose;
        $[50] = open;
        $[51] = t23;
        $[52] = t24;
    } else t24 = $[52];
    return t24;
};
export { AddImagesGalleryDialog };
